export default function volumeDetector(
  stream: MediaStream,
  onChange: (volume: number) => void
) {
  let localDbValues: number[] = [];
  const context = new AudioContext();
  const source = context.createMediaStreamSource(stream);
  const processor = context.createScriptProcessor(2048, 1, 1);
  const analyser = context.createAnalyser();

  analyser.minDecibels = -100;
  analyser.maxDecibels = -10;
  analyser.smoothingTimeConstant = 0.8;
  analyser.fftSize = 256;

  source.connect(analyser);
  analyser.connect(processor);
  processor.connect(context.destination);

  let average = 0;

  const processAudio = () => {
    const data = new Uint8Array(analyser.frequencyBinCount);
    analyser.getByteFrequencyData(data);
    let values = 0;

    const length = data.length;
    for (let i = 0; i < length; i++) {
      //if (data[i]>130) data[i]=130;
      values += data[i];
    }

    average = values / data.length;
    if (isFinite(average)) {
      localDbValues.push(average);
    }
  };

  processor.addEventListener("audioprocess", processAudio);

  let tick: number;
  const getDBReading = () => {
    const arr = localDbValues.slice();
    if (arr.length) {
      const volume = Math.round(arr.reduce((a, b) => a + b, 0) / arr.length);
      onChange(volume);
      localDbValues = [];
    }
    tick = requestAnimationFrame(getDBReading);
  };
  getDBReading();
  return () => {
    cancelAnimationFrame(tick);
    processor.removeEventListener("audioprocess", processAudio);
  };
}
